import { SubscriptionManagement } from '../../store/SubscriptionsManagement/subscriptionsManagementTypes';

export const getSubscriptionImage = (subscription: SubscriptionManagement) => {
  if (subscription.image) {
    return subscription.image;
  }

  if (subscription.categoryObjects.length > 1) {
    return 'https://static.ashtrom-host.co.il/resources/1687945339303-resources.jpeg';
  }

  return subscription.categoryObjects[0].image;
};
